module.exports = __webpack_public_path__ + "img/abcorder_tab.6b1dee8a.jpg";